module.exports = __webpack_public_path__ + "img/8989efa9021bf3b1f9d04486fdff5563.gif";